module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAQlBMVEUAAABckTtckTtckTtckTtckTtckTtmmEfW5M7///9ckTuFrWxwn1TC1rbg6trM3cKuyJ2ZuoW4z6mPs3jr8eejwZFPSllgAAAAB3RSTlMAYL8AIM/vi50ITwAAANJJREFUeF7t2LsOwyAMQFGesQ3k3f7/r5aoytSgFNlSh/qODGcABrA5si4xctbXjPchJmYxHFAYErshVCgmgaI3NolkjZOBnElC/Q0EIAIBEj3GZ77VSn6ODyKEBoR0NuG8LEv+qC7OONEZXkOFuruGQApK2Otge7M7am92razblxhua7m7kJD3ejgtoR7nnqHjZr+B1soPIIUUUkghhRRSSCGFuE8//mNU/nks/2Cn7kAY4n+zuB8/aHz8GCnUk9iQRWzsIzWIEhuNSQ7rahLjwxffEMYdt8cZDQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/264a.png
// module id = 1352
// module chunks = 0